import axios from "axios";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getRawDataUrlParams, getDownloadParams } from "./rawDataActionUtils";
import { getPostInfo } from "../components/MainContent/RawData/RawDataCard/postInfoUtils";
export const BLOCK_SOURCE_MESSAGE = "BLOCK_SOURCE_MESSAGE";
export const FETCH_RAW_DATA = "FETCH_RAW_DATA";
export const FETCH_POST_INFO = "FETCH_POST_INFO";
export const FETCH_MORE_RAW_DATA = "FETCH_MORE_RAW_DATA";
export const REMOVE_IRR_POST = "REMOVE_IRR_POST";
export const SENTIMENT_UPDATE = "SENTIMENT_UPDATE";
export const BULK_SENTIMENT_UPDATE = "BULK_SENTIMENT_UPDATE";
export const BULK_MARK_IRR_UPDATE = "BULK_MARK_IRR_UPDATE";
export const ADD_TO_COLLECTION = "ADD_TO_COLLECTION";
export const SET_CREATE_SPARK_MODAL_SHOW = "SET_CREATE_SPARK_MODAL_SHOW";
export const SET_TAG_CLIENT_MODAL_SHOW = "SET_TAG_CLIENT_MODAL_SHOW";
export const GET_TEAMS_I_BELONG_TO = "GET_TEAMS_I_BELONG_TO";
export const GET_CLIENTS = "GET_CLIENTS";
export const VALIDATE_TOKEN = "VALIDATE_TOKEN";
export const EMAIL_POST = "EMAIL_POST";
export const ADD_SPARK = "ADD_SPARK";
export const TAG_CLIENT = "TAG_CLIENT";
export const SET_PLATFORM_NAME = "SET_PLATFORM_NAME";
export const UPDATE_MARK_IRR_FOR_ALL = "UPDATE_MARK_IRR_FOR_ALL";
export const UPDATE_SENTIMENT_FOR_ALL = "UPDATE_SENTIMENT_FOR_ALL";
export const UPDATE_SENTIMENT_FOR_VIRAL_POSTS = "UPDATE_SENTIMENT_FOR_VIRAL_POSTS";
export const UPDATE_MARK_IRR_FOR_VIRAL_POSTS = "UPDATE_MARK_IRR_FOR_VIRAL_POSTS";
export const NEW_TOTAL_COUNT = "NEW_TOTAL_COUNT";
export const LISTEN_TICKET_DETAILS = "LISTEN_TICKET_DETAILS";
var moment = require("moment");

export function updateMarkIrrForAll(val, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, non_ids, isViralityPage) {
    let nonId_arr = [];
    if (non_ids.length > 0) {
        non_ids.forEach((x, i) => {
            nonId_arr[i] = non_ids[i].split(":")[1];
        });
    }
    let data = getRawDataUrlParams(filter, 1, sortOption, influencers, sentiment, sentimentType, media, channel, postType);
    data.append("version", "v7");
    data.append("bulk_update[spam.is_spam]", 2);
    data.append("bulk_update[spam.description]", val);
    data.append("access-token", getAccessToken());
    data.append("not_es_id", nonId_arr.length > 0 ? nonId_arr.toString() : null);
    if (isViralityPage == true) data.append("virality_parameter", 1);

    let req = axios({
        method: "post",
        url: getUrl("all_update"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: UPDATE_MARK_IRR_FOR_ALL,
        payload: req,
    };
}

export function updateMarkIrrForAlreadyViralPosts(val, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, non_ids) {
    let nonId_arr = [];
    if (non_ids.length > 0) {
        non_ids.forEach((x, i) => {
            nonId_arr[i] = non_ids[i].split(":")[1];
        });
    }
    let data = getRawDataUrlParams(filter, 1, sortOption, influencers, sentiment, sentimentType, media, channel, postType);
    data.append("version", "v7");
    data.append("bulk_update[spam.is_spam]", 2);
    data.append("bulk_update[spam.description]", val);
    data.append("access-token", getAccessToken());
    data.append("not_es_id", nonId_arr.length > 0 ? nonId_arr.toString() : null);
    data.append("virality_parameter", 0);

    let req = axios({
        method: "post",
        url: getUrl("all_update"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: UPDATE_MARK_IRR_FOR_VIRAL_POSTS,
        payload: req,
    };
}

export function updateSentimentForAll(val, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, non_ids, isViralityPage) {
    let nonId_arr = [];
    if (non_ids.length > 0) {
        non_ids.forEach((x, i) => {
            nonId_arr[i] = non_ids[i].split(":")[1];
        });
    }
    let data = getRawDataUrlParams(filter, 1, sortOption, influencers, sentiment, sentimentType, media, channel, postType);
    data.append("version", "v7");
    data.append("bulk_update[sentiments.sentiment]", val.toLowerCase());
    data.append("bulk_update[sentiments.source]", 12);
    data.append("access-token", getAccessToken());
    data.append("not_es_id", nonId_arr.length > 0 ? nonId_arr.toString() : null);
    if (isViralityPage == true) data.append("virality_parameter", 1);

    let req = axios({
        method: "post",
        url: getUrl("all_update"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: UPDATE_SENTIMENT_FOR_ALL,
        payload: req,
    };
}

export function updateSentimentForAlreadyViralPosts(val, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, non_ids) {
    let nonId_arr = [];
    if (non_ids.length > 0) {
        non_ids.forEach((x, i) => {
            nonId_arr[i] = non_ids[i].split(":")[1];
        });
    }
    let data = getRawDataUrlParams(filter, 1, sortOption, influencers, sentiment, sentimentType, media, channel, postType);
    data.append("version", "v7");
    data.append("bulk_update[sentiments.sentiment]", val.toLowerCase());
    data.append("bulk_update[sentiments.source]", 12);
    data.append("access-token", getAccessToken());
    data.append("not_es_id", nonId_arr.length > 0 ? nonId_arr.toString() : null);
    data.append("virality_parameter", 0);

    let req = axios({
        method: "post",
        url: getUrl("all_update"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: UPDATE_SENTIMENT_FOR_VIRAL_POSTS,
        payload: req,
    };
}

export function downloadAction(ext, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, sampling, exclusion) {
    let data = getDownloadParams(ext, filter, sortOption, influencers, sentiment, sentimentType, media, channel, postType, sampling, exclusion);
    data.append("access-token", getAccessToken());
    return function (dispatch) {
        axios
            .post(getUrl("download"), data, { "Content-Type": "application/x-www-form-urlencoded" })
            .then((response) => {
                toast.success("Your Download request has been received and you will shortly receive an email with the Download link.");
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("Some error occurred while processing your request");
            });
    };
}

export function fetchRawData(
    filter,
    offset,
    sortOption,
    influencers,
    sentiment,
    sentimentType,
    media,
    channel,
    postType,
    exclusion,
    sampling,
    searchDataType,
    allDataCharts,
) {
    // console.log(channel)
    let data = getRawDataUrlParams(
        filter,
        offset,
        sortOption,
        influencers,
        sentiment,
        sentimentType,
        media,
        channel,
        postType,
        exclusion,
        sampling,
        searchDataType,
        allDataCharts,
    );
    let current_id = window.location.hash.split("/")[2];
    let all_filters = JSON.parse(localStorage.getItem("filters"));
    let view_name = all_filters.filter((elem) => elem.id === parseInt(current_id) && elem.view_type === "system");
    if (
        view_name.length &&
        (view_name[0].name.toLowerCase() === "social" || view_name[0].name.toLowerCase() === "social+news" || view_name[0].name.toLowerCase() === "news")
    ) {
        data.append("exclude_account_type", "1,2,3");
        data.append("fields_not_exist", "account_types");
    }
    let req = axios({
        method: "post",
        url: getUrl("raw_data"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
        //}).then(res => ({ ...res.data, offset }))
    }).then((res) => {
        // console.log(res);
        if (res.status == "401") {
            localStorage.clear();
            sessionStorage.clear();
            document.cookie = "accessToken" + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            window.location.href = window.location.origin + "/signin";
        } else {
            return { ...res.data, offset };
        }
    });

    return {
        type: FETCH_RAW_DATA,
        payload: req,
    };
}

export function FetchNewPostsCount(filter, offset, sortOption, influencers, sentiment, sentimentType, media, channel, postType, exclusion, sampling) {
    let data = getRawDataUrlParams(filter, offset, sortOption, influencers, sentiment, sentimentType, media, channel, postType, exclusion, sampling);
    let current_id = window.location.hash.split("/")[2];
    let all_filters = JSON.parse(localStorage.getItem("filters"));
    let view_name = all_filters.filter((elem) => elem.id === parseInt(current_id) && elem.view_type === "system");
    if (
        view_name.length &&
        (view_name[0].name.toLowerCase() === "social" || view_name[0].name.toLowerCase() === "social+news" || view_name[0].name.toLowerCase() === "news")
    ) {
        data.append("exclude_account_type", "1,2,3");
        data.append("fields_not_exist", "account_types");
    }
    data.delete("data");

    return function (dispatch) {
        axios
            .post(getUrl("raw_data"), data, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({ type: NEW_TOTAL_COUNT, count: response.data.hits.total });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // let req = axios({
    // 	method: 'post',
    // 	url: getUrl('raw_data'),
    // 	headers: {
    // 		'Content-Type': 'application/x-www-form-urlencoded'
    // 	},
    // 	data
    // }).then(res => ({ ...res.data, offset }))

    // return {
    // 	type: FETCH_RAW_DATA,
    // 	payload: req
    // }
}

export function removeIrrPost(type, val, postId, company) {
    let data = {
        "spam.is_spam": 2,
        _ids: postId,
    };
    //data.append('spam.is_spam', 2)
    if (["duplicate", "unwanted_ad"].indexOf(type) > -1) {
        data["spam.description"] = type;
    } else if (type === "block source") {
        data["spam.url"] = val;
        data["spam.description"] = "block_source";
        data["twenty20_username"] = JSON.parse(localStorage.getItem("company")).user_name;
    } else {
        data["spam.description"] = val;
    }
    let req = axios({
        method: "post",
        url: getUrl("irrelevant_post"),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${company.lite_access_token}`,
        },
        data,
    }).then((res) => {
        return { res: res.data, type, val, postId: postId.split(":")[1] };
    });

    return {
        type: REMOVE_IRR_POST,
        payload: req,
    };
}

export function setSentimentCommentSection(sentiment, id, company, rawData) {
    return function (dispatch) {
        var params = {
            _ids: id,
            "sentiments.sentiment": sentiment,
        };
        params = JSON.stringify(params);
        axios
            .post(getUrl("sentiment_update"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${company.lite_access_token}`,
                },
            })
            .then((response) => {
                dispatch({ type: SENTIMENT_UPDATE, payload: rawData });
            })
            .catch((error) => {
                toast.error("Something went wrong while updating sentiment.");
            });
    };
}

export function setSentiment(different_ids, sentiment, company, rawData) {
    return function (dispatch) {
        for (var i = 0; i < different_ids.length; i++) {
            let _id = different_ids[i].split(":")[1];
            let _index = different_ids[i].split(":")[0];
            let dataIndex = rawData.findIndex((elem) => elem._id === _id);
            let data = rawData[dataIndex];
            let sentimentsArray = data && data._source.sentiments;
            let companyIndexInSentimentArray = sentimentsArray.findIndex((elem) => parseInt(elem.company_id) === parseInt(company.company_lite_company_id));
            if (companyIndexInSentimentArray !== -1) {
                sentimentsArray[companyIndexInSentimentArray].sentiment = sentiment.toUpperCase();
                data._source.sentiments = sentimentsArray;
                rawData[dataIndex] = data;
            } else {
                let newSentimentObj = {
                    sentiment: sentiment.toUpperCase(),
                    company_id: company.company_lite_company_id,
                    source: 12,
                };
                sentimentsArray.push(newSentimentObj);
                data._source.sentiments = sentimentsArray;
                rawData[dataIndex] = data;
            }
            dispatch({ type: SENTIMENT_UPDATE, payload: rawData });
        }
        var params = {
            _ids: different_ids.toString(),
            "sentiments.sentiment": sentiment,
        };
        params = JSON.stringify(params);
        axios
            .post(getUrl("sentiment_update"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${company.lite_access_token}`,
                },
            })
            .then((response) => {})
            .catch((error) => {});
    };
}

export function bulkSentimentUpdate(different_ids, sentiment, company, rawData, non_ids) {
    return function (dispatch) {
        for (var i = 0; i < different_ids.length; i++) {
            let _id = different_ids[i].split(":")[1];
            let _index = different_ids[i].split(":")[0];
            let dataIndex = rawData.findIndex((elem) => elem._id === _id);
            let data = rawData[dataIndex];
            let sentimentsArray = data && data._source.sentiments;
            if (sentimentsArray !== undefined) {
                let companyIndexInSentimentArray = sentimentsArray.findIndex((elem) => parseInt(elem.company_id) === parseInt(company.company_lite_company_id));
                if (companyIndexInSentimentArray !== -1) {
                    sentimentsArray[companyIndexInSentimentArray].sentiment = sentiment.toUpperCase();
                    data._source.sentiments = sentimentsArray;
                    rawData[dataIndex] = data;
                } else {
                    let newSentimentObj = {
                        sentiment: sentiment.toUpperCase(),
                        company_id: company.company_lite_company_id,
                        source: 12,
                    };
                    sentimentsArray.push(newSentimentObj);
                    data._source.sentiments = sentimentsArray;
                    rawData[dataIndex] = data;
                }
                dispatch({ type: BULK_SENTIMENT_UPDATE });
            }
        }
        var params = {
            _ids: different_ids.length !== 0 ? different_ids.toString() : null,
            not_es_id: non_ids ? non_ids.toString() : null,
            "sentiments.sentiment": sentiment,
        };
        params = JSON.stringify(params);
        axios
            .post(getUrl("sentiment_update"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${company.lite_access_token}`,
                },
            })
            .then((response) => {
                dispatch({ type: SENTIMENT_UPDATE, payload: rawData });
            })
            .catch((error) => {
                //console.log(error);
            });
    };
}

export function bulkMarkIrrUpdate(ids, description, company, non_ids) {
    let different_ids = [];
    if (ids.length !== 0) {
        ids.forEach((id) => {
            different_ids.push(id.split(":")[1]);
        });
    }
    let data = {
        "spam.is_spam": 2,
        _ids: ids.length !== 0 ? ids.toString() : null,
        not_es_id: non_ids ? non_ids.toString() : null,
    };
    data["spam.description"] = description;
    let req = axios({
        method: "post",
        url: getUrl("bulk_mark_irr_update"),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${company.lite_access_token}`,
        },
        data,
    }).then((res) => {
        return { res: res.data, ids: different_ids };
    });

    return {
        type: BULK_MARK_IRR_UPDATE,
        payload: req,
    };
}

export function createSparkModalShowSet(show, title, url, image) {
    return {
        type: SET_CREATE_SPARK_MODAL_SHOW,
        payload: { show, title, url, image },
    };
}

export function tagClientModalShowSet(show) {
    return {
        type: SET_TAG_CLIENT_MODAL_SHOW,
        payload: { show },
    };
}

export function getClients() {
    let req = axios({
        method: "get",
        //url: getUrl('get_clients'),
        url: getUrl("get_clients"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    }).then((res) => res.data);
    return {
        type: GET_CLIENTS,
        payload: req,
    };
}

export function validateToken() {
    let req = axios({
        method: "get",
        //url: getUrl('get_clients'),
        url: getUrl("validate_token"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    }).then((res) => {
        if (res.data.status != "success") {
            localStorage.clear();
            sessionStorage.clear();
            document.cookie = "accessToken" + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            window.location.href = window.location.origin + "/signin";
            return { ...res.data };
        } else {
            return { ...res.data };
        }
    });
    return {
        type: VALIDATE_TOKEN,
        payload: req,
    };
}

export function getTeamsIBelongTo(callback) {
    let req = axios
        .get(`${getUrl("get_company_teams")}`, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => {
            if (callback) {
                callback();
            }
            return res.data.data;
        });

    return {
        type: GET_TEAMS_I_BELONG_TO,
        payload: req,
    };
}

export function emailPost(toAddr, subject, content, logo) {
    // let data = new URLSearchParams();
    // data.append("mail_to", toAddr);
    // data.append("mail_subject", subject);
    // data.append("mail_body", content);

    let data = {};
    data["mail_to"] = toAddr;
    data["mail_subject"] = subject;
    data["mail_body"] = content;
    const defaultLogo = "https://radarassets.s3.amazonaws.com/circussocial1_circussocial1admin_1682002526340.png";
    data["companyLogo"] = logo || defaultLogo;
    data["heading"] = "Post";

    let req = axios({
        method: "post",
        url: getUrl("email_post"),
        headers: {
            "Content-Type": "application/json",
        },
        data,
    }).then((res) => res.data);

    return {
        type: EMAIL_POST,
        payload: req,
    };
}

export function createSpark(sparkInfo) {
    let data = new URLSearchParams();
    data.append("title", sparkInfo.title);
    data.append("link", sparkInfo.link);
    data.append("image", sparkInfo.image);
    data.append("message", sparkInfo.message);
    if (sparkInfo.accessType === "own") data.append("access_type", 0);
    else {
        data.append("access_type", 2);
        data.append("access_value", sparkInfo.accessTeams.join(","));
    }

    let req = axios({
        method: "post",
        url: getUrl("add_spark"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: ADD_SPARK,
        payload: req,
    };
}

export function tagClient(id, cmpny_list) {
    let data = new URLSearchParams();
    data.append("_id", id);
    data.append("company_ids", cmpny_list);
    let req = axios
        .post(getUrl("tag_client"), data, { "Content-Type": "application/x-www-form-urlencoded" })
        .then((response) => {
            toast.success("Successfully tagged to clients");
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    return { type: TAG_CLIENT, payload: req };
}

export function fetchPostInfo(id) {
    let data = new URLSearchParams();
    data.append("_id", id);
    let req = axios({
        method: "post",
        url: getUrl("postInfo"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => res.data)
        .then((d) => ({ ...d, post_id: id }));
    return {
        type: "FETCH_POST_INFO",
        payload: req,
    };
}

export function setPlatformName(platformName) {
    return {
        type: "SET_PLATFORM_NAME",
        payload: platformName,
    };
}

export function fetchPostComments(id, published_date) {
    let data = new URLSearchParams();

    data.append("access-token", getAccessToken());
    data.append("parent_id", id);
    data.append("offset", 1);
    data.append("recordsPerPage", 1000);
    var now = moment(new Date());
    var end = moment(new Date(published_date));
    var duration = moment.duration(now.diff(end));
    var days = duration.asDays();
    data.append("duration", Math.ceil(days) + 1);
    data.append("data", 1);
    data.append("post_type", 1);

    let req = axios({
        method: "post",
        url: getUrl("post_comments"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => res.data)
        .then(formatPostComments);

    return {
        type: "FETCH_POST_COMMENTS",
        payload: req,
    };
}

const formatPostComments = (data) => {
    return data.hits.hits.map((elem) => {
        return { ...getPostInfo(elem, JSON.parse(localStorage.getItem("company")).company_lite_company_id), _id: elem._index + ":" + elem._id };
    });
};

export function fetchPostReplys(id) {
    let data = new URLSearchParams();

    data.append("access-token", getAccessToken());
    data.append("parent_id", id);
    data.append("offset", 1);
    data.append("recordsPerPage", 1000);
    data.append("post_type", 1);

    let req = axios({
        method: "post",
        url: getUrl("post_comments"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => res.data)
        .then(formatPostComments);

    return {
        type: "FETCH_POST_REPLYS",
        payload: req,
    };
}

export function changeCommentSentiment(comments) {
    return function (dispatch) {
        dispatch({ type: "FETCH_POST_COMMENTS_FULFILLED", payload: comments });
    };
}

export function FetchBlockSourceMessage(obj, callback) {
    return function (dispatch) {
        axios
            .post(getUrl("block_source_meesage"), obj, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem("company")).lite_access_token}`,
                },
            })
            .then((response) => {
                callback();
                dispatch({ type: BLOCK_SOURCE_MESSAGE, payload: response.data.data });
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export function AutoPushCall(bool) {
    return function (dispatch) {
        dispatch({ type: "AUTO_PUSH_CALL", payload: bool });
    };
}

export function updateListenPost(param) {
    let res = axios({
        method: "POST",
        url: `${getUrl("smr_service")}/sync/listening-smr/_bulk`,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response?.data?.message);
            // throw err;
            return {
                error: 1,
            };
        });
    return {
        type: "LISTEN_TICKET_DETAILS",
        payload: res,
    };
}
